import { useEffect, type ReactNode } from 'react';

import { createAppKit, useAppKitTheme } from '@reown/appkit/react';
// import { BitcoinAdapter } from '@reown/appkit-adapter-bitcoin';
import { WagmiProvider } from 'wagmi';

import { REOWN_CONFIG, wagmiAdapter } from './config';

// export const bitcoinAdapter = new BitcoinAdapter({ projectId: import.meta.env.VITE_APPKIT_PROJECT_ID });

export const reownModal = createAppKit({
  adapters: [
    wagmiAdapter,
    // bitcoinAdapter
  ],
  networks: REOWN_CONFIG.chains,
  projectId: import.meta.env.VITE_APPKIT_PROJECT_ID,
  enableInjected: false,
  metadata: {
    name: 'PACT SWAP',
    description: 'A cross-chain DEX for native $BTC, $ETH, and more',
    url: 'https://pactswap.io',
    icons: ['https://app.pactswap.io/favicon.svg'],
  },
  features: {
    analytics: true,
    socials: false,
    email: false,
  },
  // ...(REOWN_WALLET_ID_SELECTION.length > 0 && { includeWalletIds: REOWN_WALLET_ID_SELECTION }),
});

export const WagmiWrapper = ({ children }: { children: ReactNode }) => {
  const appKitTheme = useAppKitTheme();

  useEffect(() => {
    appKitTheme.setThemeVariables({
      '--w3m-font-family': 'Roboto, sans-serif',
      '--w3m-accent': 'hsl(var(--primary-purple))',
      '--w3m-color-mix': 'hsl(var(--foreground))',
      '--w3m-color-mix-strength': 40,
      '--w3m-border-radius-master': '0.15rem',
    });
  }, []);

  return <WagmiProvider config={wagmiAdapter.wagmiConfig}>{children}</WagmiProvider>;
};
